import { ButtonGroup, ButtonIcon, Card, Icon, Tooltip, CardV2 } from 'pepsico-ds'
import React, { useEffect, useState } from 'react'
import { appNames } from '../../constants/appNames'
import { useSelector, useDispatch } from 'react-redux'
import swal from 'sweetalert';
import { message } from 'antd';
import InfoIcon from '../Icons/InfoIcon';
import { formatNumberWithCommas, returnHyphenIfNull } from '../../utils/utils';
import { getUserClaims } from '../../utils/auth/unified-auth';
import ArchletModal from '../Modal/ArchletModal';
import { showChartDisplayError, useButtonItemsArray, vlaidateLandingPageFilters } from './CardUtils';
import BuyerConButtonIcon from "../Button/BuyerConButtonIcon"
import CustomButtons from './CustomButtons';
import AribaModal from '../Modal/AribaModal';
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';

function ArchletCard({ data, capability, selectedYear, userDataLandingPage, landingPageFilters, disabled=false }) {
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const [appName, setAppName] = useState('SAP Ariba');
    const [openModal, setOpenModal] = useState(false)
    // const [userData, setUserData] = useState({})
    const userData = useSelector((state) => state?.localData?.data?.oktaUserData);
    const isOnlyPGCSSelected = landingPageFilters?.allSectors?.length === 1 && landingPageFilters?.sectors?.[0]?.displayText === "PGCS";
    const userApiData = useSelector((state) => state?.getLandingPageReducer);
    const appDropdownItems = useButtonItemsArray(buttonGroupItems, setAppName, landingPageFilters, setOpenModal, openModal, capability);
    const enableKPIDisplay = [appNames.archlet].includes(capability) && appDropdownItems.length < 3 && appDropdownItems?.[1]?.chartDisplay;

    /* istanbul ignore next */
    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            const tempItems = data && data?.apps && data?.apps.length > 0 ? data?.apps?.filter(item => item.isActive)?.map((app) => ({
                label: app.app,
                chartDisplay: app.chartDisplay,
                onClick: () => window.open(app.url, "_blank"), // Opens the app in a new tab
            })) : [];
            setButtonGroupItems(tempItems)
        }
    }, [data])

    return (
        <>
            <div className="kpi-card-header">
                                <div className="kpi-card-title" title={data?.title} style={{ width:"80%",wordWrap: "break-word", whiteSpace: "normal" }}>
                                    {data?.title}
                                    {
                                        data?.edfintegrated &&
                                        <Tooltip direction="bottom" text={staticNotes.EDF_NOTE} style={{ marginTop: 13 }}>
                                            <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible" }} />
                                        </Tooltip>
                                    }
                                </div>
                                    {
                                        appDropdownItems.length === 2 ?
                                            <div className="kpi-card-header-icons">
                                                {BuyerConButtonIcon(enableKPIDisplay, landingPageFilters, setOpenModal, openModal, capability, disabled)}
                                            </div>
                                            :
                                            <ButtonGroup
                                                groupDisabled = {disabled}
                                                itemCount={1}
                                                items={appDropdownItems}
                                                showMore
                                                size="medium"
                                                className="kpiCardButtomGroup"
                                            />
                                    }   
                            </div>
                            {
                                <div className="kpi-card-middle-content">
                                    <div className="kpi-card-middle-content-left" style={{ width: '75%' }}>
                                        {
                                            data?.totalBidEvents ?
                                                <div className="kpi-card-alphanumeric-value">
                                                    {

                                                        <>
                                                            <div className='kpi-card-numeric-value'>
                                                                {formatNumberWithCommas(data?.totalBidEvents)} 
                                                            </div>
                                                            <div className="kpi-card-alpha-value" style={{ display: "flex" }}>

                                                            </div>
                                                        </>
                                                    }

                                                </div>
                                                :
                                                <div className="kpi-card-alphanumeric-value">
                                                    <div className='kpi-card-numeric-value'>N/A<sup><InfoIcon text="Data is not available for the given filter combination. Please adjust your selection." direction='right'/></sup></div>
                                                </div>
                                        }
                                        <div className="kpi-card-numeric-value-tagline">{data?.description}</div>
                                        <div className="kpi-card-last-update">
                                            {data?.lastUpdate ? (
                                                <>
                                                    <div>{data?.lastUpdate}</div>
                                                    {data?.refreshFrequency && <div>{data?.refreshFrequency}</div>}
                                                </>
                                            ) : (
                                                data?.refreshFrequency || ''
                                            )}
                                        </div>
                                    </div>
                                    <div className="kpi-card-middle-content-right">
                                        <div className="kpi-card-last-year-value" style={{ display: 'flex', flexDirection: 'column', alignItems: 'end', height: '100%' }}>
                                            {!isOnlyPGCSSelected && (
                                                <> 
                                                    {                                               
                                                        data?.totalAribaSoucingBidEvents ?
                                                            <>
                                                                <div className="kpi-card-percentage-value" style={{ width: 'fit-content', padding: '4px 9px' }}>{data?.totalAribaSoucingBidEvents}</div>
                                                            </> 
                                                            : <span className="kpi-card-percentage-value" style={{ width: 'fit-content', padding: '4px 9px' }}>0</span>
                                                    }
                                                    <span className="archlet-card-text" style={{ marginBottom: 10 }}>SAP Ariba</span>
                                                </>
                                            )}
                                            
                                            {!isOnlyPGCSSelected && (
                                                <>
                                                    {
                                                        data?.totalArchletBidEvents ?
                                                            <>
                                                                <div className="kpi-card-percentage-value" style={{ width: 'fit-content', padding: '4px 9px' }}>{data?.totalArchletBidEvents}</div>
                                                            </> 
                                                            : <span className="kpi-card-percentage-value" style={{ width: 'fit-content', padding: '4px 9px' }}>0</span>
                                                    }
                                                    <span className="archlet-card-text">Archlet</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    {/* REMOVE FOLLOWING DIV WHEN SAP ARIBA IS ENABLED */}
                                    {/* <div className="kpi-card-middle-content-right">
                                        <div className="kpi-card-last-year-value" style={{ display: 'flex', flexDirection: 'column', alignItems: 'end', height: '100%' }}>
                                            {
                                                data?.hoursSaved ?
                                                    <>
                                                        <div className="kpi-card-percentage-value" style={{ backgroundColor: '#006A42' }}>{data?.hoursSaved}
                                                            <Icon
                                                                alt="alt value"
                                                                icon={"arrow_downward"}
                                                                size="small"
                                                                style={{ color: '#fff' }}
                                                            />
                                                        </div>
                                                    </> : <span className="kpi-card-percentage-value" style={{ backgroundColor: '#006A42' }}>0</span>
                                            }
                                            <span className="archlet-card-text" style={{ marginBottom: 10 }}>Hours Saved</span>
                                            {
                                                data?.priceReductionAcrossRounds ?
                                                    <>
                                                        <div className="kpi-card-percentage-value" style={{ backgroundColor: '#006A42' }}>{data?.priceReductionAcrossRounds}%
                                                            <Icon
                                                                alt="alt value"
                                                                icon={parseFloat(data?.priceReductionAcrossRounds) == 0 ? "" : (parseFloat(data?.priceReductionAcrossRounds) > 0 ? "arrow_upward" : "arrow_downward")}
                                                                size="small"
                                                                style={{ color: '#fff' }}
                                                            />
                                                        </div>
                                                    </> : <span className="kpi-card-percentage-value" style={{ backgroundColor: '#006A42' }}>0</span>
                                            }
                                            <span className="archlet-card-text">Price Reduction</span>
                                        </div>
                                    </div> */}
                                </div>
                            }
                            <div className="kpi-card-footer">
                                <CustomButtons appList={data?.apps} disabled={disabled}/>
                            </div>
            {
                openModal && capability == appNames.archlet && appName === "Archlet" && <ArchletModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} appName={appName} />
            }
            
            {
                openModal && capability == appNames.archlet && appName === "SAP Ariba" && <AribaModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} appName={appName} />
            }
        </>
    )
}

export default ArchletCard
